import { HiOutlineDotsVertical } from "react-icons/hi"
import { MdOutlineKeyboardArrowDown } from "react-icons/md"

import { TQuestion } from "../../../api/type"
import { TiptapReadOnlyContent } from "../../../component/tiptapEditor"
import QuestionArtifacts from "../../../component/questionArtifacts/QuestionArtifacts"
import QuestionListExpandPanel from "./QuestionListExpandPanel"
import QuestionMetaChips from "./QuestionMetaChips"
import {
  formatQuestionStatus,
  formatVerificationStatus,
  getQuestionStatusClassName,
} from "../utils/questionMeta"

type QuestionListItemProps = {
  item: TQuestion
  index: number
  isOpen: boolean
  isActionOpen: boolean
  levelLabels?: string[]
  onToggleExpand: () => void
  onToggleActionMenu: (event: React.MouseEvent<SVGElement>) => void
}

const QuestionListItem = ({
  item,
  index,
  isOpen,
  isActionOpen,
  levelLabels,
  onToggleExpand,
  onToggleActionMenu,
}: QuestionListItemProps) => {
  const statusClass = getQuestionStatusClassName(item.question_status)

  return (
    <div
      className={`single_question ${statusClass}${isOpen ? " is-open" : ""}${isActionOpen ? " is-action-open" : ""}`}
    >
      <QuestionMetaChips question={item} levelLabels={levelLabels} />

      <div className="question">
        <div className="question_list__preview">
          <span>{index + 1}.</span>
          <div className="question_list__preview-body">
            <div className="question_list__badges">
              {item.question_status && (
                <span className={`question_list__status ${statusClass}`}>
                  {formatQuestionStatus(item.question_status)}
                </span>
              )}
              {item.verification_status === "unverified" && (
                <span className="question_list__status question-status--unverified">
                  {formatVerificationStatus(item.verification_status)}
                </span>
              )}
              {item.verification_status === "rejected" && (
                <span className="question_list__status question-status--rejected">
                  {formatVerificationStatus(item.verification_status)}
                </span>
              )}
              {item.question_status === "published" &&
                item.published_to_learner && (
                <span className="question_list__learner-badge is-live">
                  Live to learners
                </span>
              )}
            </div>
            <TiptapReadOnlyContent html={item?.question ?? ""} />
            <QuestionArtifacts artifacts={item.question_artifacts} />
          </div>
        </div>

        <div className="actions">
          <MdOutlineKeyboardArrowDown
            className={`arrow-icon${isOpen ? " rotate-180" : ""}`}
            onClick={(event) => {
              event.stopPropagation()
              onToggleExpand()
            }}
            tabIndex={10}
            aria-label={isOpen ? "Collapse question" : "Expand question"}
            aria-expanded={isOpen}
          />
          <HiOutlineDotsVertical
            className="dot-icon"
            onClick={(event) => {
              event.stopPropagation()
              onToggleActionMenu(event)
            }}
            tabIndex={11}
            aria-label="Question actions"
          />
        </div>
      </div>

      {isOpen && <QuestionListExpandPanel question={item} />}
    </div>
  )
}

export default QuestionListItem
